<template>
    <label
        :for="id ?? 'number-input' + _uid"
        class="group flex items-stretch rounded overflow-hidden border border-primary-20 has-[:focus]:border-secondary-80"
        :class="[width ?? 'w-fit']"
    >
        <slot name="before" :subtract="subtract" :disabled="disabled || subDisabled">
            <button
                role="button"
                class="flex items-center bg-secondary-80 hover:bg-secondary px-16 cursor-pointer border-r border-primary-20 group-has-[:focus]:border-secondary-80"
                :class="[disabled || subDisabled ? 'bg-primary-5 cursor-not-allowed text-primary' : 'bg-secondary hover:bg-secondary-80 cursor-pointer text-white']"
                :disabled="subDisabled"
                @click="subtract"
            >
                -
            </button>
        </slot>
        <input
            :value="inputValue"
            :min="min"
            :max="max"
            :disabled="disabled"
            type="text"
            :id="id ?? 'number-input' + _uid"
            class="text-center flex-1 py-8 ring-0 outline-0"
            :class="[width ? 'flex-1' : 'w-76']"
            @input="handleInput"
        >
        <slot name="after" :add="add" :disabled="disabled || addDisabled">
            <button
                role="button"
                class="flex items-center bg-secondary-80 hover:bg-secondary px-16 cursor-pointer border-l border-primary-20 group-has-[:focus]:border-secondary-80"
                :class="[disabled || addDisabled ? 'bg-primary-5 cursor-not-allowed text-primary' : 'bg-secondary hover:bg-secondary-80 cursor-pointer text-white']"
                :disabled="addDisabled"
                @click="add"
            >
                +
            </button>
        </slot>
    </label>
</template>
<script>
import SimpleInput from "../forms/Input.vue";
import Tooltip from "../navigation/Tooltip.vue";
import _debounce from 'lodash/debounce';

export default {
    name: "NumberInput",
    components: {Tooltip, SimpleInput},
    props: {
        value: Number|String,
        min: Number,
        max: Number,
        disabled: Boolean,
        subDisabled: Boolean,
        addDisabled: Boolean,
        width: String,
        id: String,
    },
    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        handleInput: _debounce(function (event) {
            let value = parseInt(event.target.value);
            if (value < this.min) {
                value = parseInt(this.min);
            } else if (value > this.max) {
                value = parseInt(this.max);
            }
            this.inputValue = value;
        }, 500),
        add() {
            if (!this.max || this.inputValue < this.max) {
                this.inputValue += 1;
            }
        },
        subtract() {
            if (this.inputValue > this.min) {
                this.inputValue -= 1;
            }
        }
    }
}
</script>
<style scoped>

</style>